<template>
    <div class="messageContainer">
        <div class="messageHeader">
            <div class="imageContainer">
                <img width="25" height="25" :src="loadFile(images.cart)">
            </div>
            <div class="texts">
                <div class="headerText">{{ message?.content?.interactive?.header?.text }}</div>
                <div class="productsCount">{{ productsCount }} {{ $t('Products') }}</div>
            </div>
        </div>
        <div class="bodyText">
            {{ message?.content?.interactive?.body?.text }}
        </div>
    </div>
</template>
<script setup>
import { loadFile } from '@/components/utils'
import { ref, onMounted } from 'vue';

const images = {
    cart: 'cart.svg'
}

const productsCount = ref(0)

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
    profile: String
});

onMounted(() => {
    const messageSections = props?.message?.content?.interactive?.action?.sections
    productsCount.value = Array.isArray(messageSections) ? messageSections[0]?.product_items.length : 0
})
</script>


<style scoped lang="scss">
.messageContainer {
    padding: 12px;
    background: #FAE4CB;
    border-radius: 8px;
    max-width: 400px;

    .messageHeader {
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: max-content;
        background: #dbc3a7;
        border-radius: 8px;

        .imageContainer {
            display: grid;
            justify-content: center;
            align-items: center;
            background: #FFF;
            height: 100%;
            width: 60px;
            border-radius: 0 8px 8px 0;
        }

        .texts {
            padding: 16px;

            .headerText {
                font-size: 12px;
                font-weight: 500;
                line-height: 14px;
                color: #0C111D;
            }

            .productsCount {
                font-size: 12px;
                font-weight: 400;
                color: #344054;
            }
        }
    }

    .bodyText {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        margin-top: 8px;
    }
}
</style>